var BookmarkButton  = require("app/Bookmarks/BookmarkButton"),
    HeaderVariables = require("app/theme/styles/headers/HeaderVariables"),
    Layout          = require("./CompactHeaderLayout"),
    PlayMediaButton = require("app/MediaPlayer/PlayMediaButton"),
    ShareButton     = require("app/Sharing/ShareButton"),
    SignUpButton    = require("app/Auth/SignUpButton"),
    frameThrottle   = require("enyo-perf/utils").frameThrottle,
    get             = require("object-path").get,
    kind            = require("enyo/kind");

require("./CompactHeader.less");
require("app/theme/IconButton--neutral.less");
require("app/theme/IconButton--neutral-ghost.less");

module.exports = kind(/** @lends  app.ui.header.CompactHeader.prototype */ {

    /**
     * @private
     */
    name: "app.ui.header.CompactHeader",

    /**
     * @private
     */
    classes: "app-ui-header-compact-header",

    /**
     * @private
     */
    layoutKind: Layout,

    /**
     * The dataset
     *
     * @type  {?Object}
     * @public
     */
    data: null,

    /**
     * @private
     */
    components: [{
        name:    "title",
        classes: "app-ui-header-compact-header__title",
        tag:     "h1"
    }, {
        name:    "playMediaButton",
        kind:    PlayMediaButton,
        classes: "app-ui-header-compact-header__play-media-button",
        theme:   "neutral"
    }, {
        name:    "signUpButton",
        kind:    SignUpButton,
        classes: "app-ui-header-compact-header__sign-up-button",
        theme:   "neutral-ghost"
    }, {
        name:        "bookmarkButton",
        kind:        BookmarkButton,
        classes:     "app-ui-header-compact-header__bookmark-button",
        theme:       "neutral-ghost",
        showCaption: false
    }, {
        name:        "shareButton",
        kind:        ShareButton,
        classes:     "app-ui-header-compact-header__share-button",
        theme:       "neutral-ghost",
        showCaption: false
    }],

    /**
     * @private
     */
    observers: {
        update: ["data"]
    },

    /**
     * @method
     * @private
     */
    create: kind.inherit(function(sup) {
        return function() {
            this.updateAndResize = frameThrottle(this.bindSafely(this.updateAndResize));
            this.lazyResize      = frameThrottle(this.bindSafely(this.resize));
            sup.apply(this, arguments);
            this.observe("app.$.i18nService.translation", this.updateAndResize);
            this.observe("app.$.authService.isLoggedIn", this.updateAndResize);

            /**
             * @important Observe this property straight from the bookmark
             * button.
             *
             * The observer style usually applied in this application would be:
             *
             * ```
             * this.observe('$.bookmarkButton.showing', this.lazyResize);
             * ```
             *
             * However, this appears to fire `this.lazyResize` before the
             * bookmarkButton fires it's `showingChanged` method, which is
             * responsible for updating the button's visibility in the DOM.
             *
             * We want our layout to respond to the change in visibility though,
             * so it's important the reflow happens after the DOM has been
             * updated. Observing directly on the button instead of using an
             * observer path seems to enforce this behavior.
             */
            this.$.playMediaButton.observe("showing", this.lazyResize);
            this.$.signUpButton.observe("showing", this.lazyResize);
            this.$.bookmarkButton.observe("showing", this.lazyResize);
            this.$.shareButton.observe("showing", this.lazyResize);
            this.updateAndResize();
        };
    }),

    /**
     * This component needs to resize after it's been updated, but we want the
     * update function to be extensible. This method allows us to resize after
     * all updates are done.
     *
     * @private
     */
    updateAndResize: function() {
        this.update();
        this.resize();
    },

    /**
     * Update the contents of the header.
     *
     * @note When extending this method, put the changes before the call to the
     * super method, because this method will call a reflow at the end.
     * @public
     */
    update: function() {
        var data          = this.data || {},
            mediaType     = get(data, "type", null),
            $signUpButton = this.$.signUpButton;

        this.$.title.set("content", get(data, "meta.title", null) || "");

        if (HeaderVariables.getSignUpButtonVisibility(mediaType) && $signUpButton.shouldShow()) {
            $signUpButton.show();
        }
        else {
            $signUpButton.hide();
        }

        this.$.bookmarkButton.set("mediaItem", data);
        this.$.shareButton.set("mediaItem", data);
    }

});
